module.exports = __webpack_public_path__ + "static/media/btn_close_x.3f65f771.svg";